import {Component, Input, OnInit} from '@angular/core';
import {Property} from "../../../model/property";
import {DownloadService} from "../../../service/download.service";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-download-modal',
    templateUrl: './download-modal.component.html',
    styleUrls: ['./download-modal.component.css']
})
export class DownloadModalComponent implements OnInit {

    @Input()
    property: Property;
    @Input()
    dialogRef: MatDialogRef<DownloadModalComponent>

    constructor(private downloadService: DownloadService) {
    }

    ngOnInit(): void {}

    async downloadAllDocumentsForProperty(property: Property) {
      const batchStarted = await this.downloadService.downloadForProperty(property, false);
      this.dialogRef.close(batchStarted);
    }

    public closeDialog(): void{
        this.dialogRef.close(false);
    }


}
